import { Button } from "@humanex/ui/components";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";

export const Route = createFileRoute("/_authenticated/profile")({
  component: OrgLayout
});

/// Note: This is a layout route
function OrgLayout() {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-primary-50">
      <div className="flex flex-col flex-1 overflow-hidden">
        <div className="py-4 px-2 md:px-4 lg:px-8">
          <div className="space-y-4 sm:space-y-6 max-w-4xl mx-auto">
            <Button
              variant="ghost"
              padding="py-2 pl-2 pr-3"
              className="flex items-center bg-white font-medium text-primary-700 hover:bg-primary-100"
              onClick={() => window.history.back()}
            >
              <ChevronLeft className="mr-[3px]" size={20} />
              Back
            </Button>
          </div>
        </div>
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
